import HybridConfig from "lib/HybridConfig";
import LockApi from "data/LockApi";
import lockStore from "data/lockStore";
import usePeriodicTask from "lib/usePeriodicTask";

const DEFAULT_POLL_INTERVAL = 60 * 1000;

function LockListener() {
    usePeriodicTask(
        () => lockStore.getActiveLocksetIds()
            .forEach(LockApi.confirmLockset),
        HybridConfig.get(
            "lockMonitoring.pollInterval",
            DEFAULT_POLL_INTERVAL,
        ),
        [],
    );
    return null;
}

export default LockListener;



// WEBPACK FOOTER //
// ./app/lib/lock/LockListener.js